<template>
  <div class="block">
    <h5 class="analysis_title">基本统计</h5>
    <div class="analysis_panel">
      <div class="analysis">
        <div>
          <span>平台考生总数</span>
          <div>{{ analysisInfo.userCount + 300000 }}</div>
        </div>
      </div>
      <div class="analysis blue">
        <div>
          <span>平台报考总数</span>
          <div>{{ analysisInfo.enrolCount + 300000 }}</div>
        </div>
      </div>
    </div>

    <div class="analysis_panel">
      <div class="analysis green">
        <div>
          <span>总点击量</span>
          <div>32012571</div>
        </div>
      </div>
      <div class="analysis gray">
        <div>
          <span>当年点击量</span>
          <div>150212</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { analysisRes } from "@/api";
export default {
  data() {
    return {
      analysisInfo: {
        enrolCount: 0,
        userCount: 0,
      },
    };
  },
  mounted() {
    this.loadData();
  },
  methods: {
    loadData() {
      analysisRes.getAnalysisCount().then((res) => {
        this.analysisInfo = res;
      });
    },
  },
};
</script>
<style lang="scss">
.analysis_panel {
  padding: 0 20%;
  margin-bottom: 40px;
  // display: flex;
  // overflow: hidden;
  // justify-content: space-around;
  & > .analysis:nth-last-of-type(1) {
    float: right;
  }
}
.analysis {
  height: 150px;
  width: 150px;
  border-radius: 100%;
  background-color: $main_color;
  color: #fff;
  text-align: center;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  div > div {
    font-size: 24px;
  }
  div > span {
    margin-bottom: 10px;
    display: inline-block;
  }
  &.blue {
    background-color: #307acc;
  }
  &.green {
    background-color: #41d73c;
  }
  &.gran{
    background-color: #b16233;
  }
}
.analysis_title {
  position: relative;
  margin: 0;
  padding-left: 10px;

  margin-bottom: 43px;
  &::before {
    position: absolute;
    content: "";
    width: 3px;
    height: 100%;
    top: 0;
    bottom: 0;
    left: 0;
    margin: auto;
    background-color: $main_color;
  }
}
</style>